export enum BuilderType {
  form = 0,
  license = 1,
  portal = 2,
  certificate = 3,
  template = 4,
  objectModel = 5,
  listView = 6,
  detailView = 7,
  mapping = 8,
  publicProfile = 9,
  entityType = 10,
  visualization = 11,
  dashboard = 12,
  processFlow = 13,
  userType = 14,
  systemDiagram = 15,
}